import styled from 'styled-components'

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const styles = {
  root: {
    flexGrow: 1
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 12
  },
  userButton: {
    marginLeft: 12,
    marginRight: -12
  },
  upload: {
    borderRadius: '10%',
    width: '60px',
    height: '60px',
    fontSize: '44px'
  }
}




// WEBPACK FOOTER //
// ./src/pages/AccountLocation/styles.js